<div class="flex flex-row items-center justify-start">
	<div
		*ngIf="this.range$ | async as range"
		#parentRef
		class="tr-group mat-bg-card flex flex-row items-center justify-start rounded-full px-1.5 py-1"
	>
		<button
			(click)="this.goBack(range)"
			[disabled]="disabled"
			class="tr-left-btn"
			fxHide.lt-md
			mat-icon-button
		>
			<mat-icon>chevron_left</mat-icon>
		</button>
		<button
			(click)="this.openRangePicker(parentRef)"
			[disabled]="disabled"
			[matTooltip]="'utils.pickTimeRange' | translate"
			[matTooltipDisabled]="disabled"
			[style.width.px]="fixedMidButtonWidth"
			class="tr-mid-btn"
			mat-button
		>
			<div class="flex flex-row items-center justify-start gap-1">
				<mat-icon
					class="mr-2 text-lg"
					fxHide.gt-sm
					inline
				>
					calendar_today
				</mat-icon>
				<ng-container
					*ngTemplateOutlet="
            (this.range$SameDay | async)
              ? sameDayTemplate
              : (this.range$SameYear | async)
                ? sameYearTemplate
                : defaultDayViewTemplate
          "
				></ng-container>
				<ng-template #sameDayTemplate>{{ range.from | formatDate: 'PP' }}</ng-template>
				<ng-template #sameYearTemplate>
					<span>{{ range.from | formatDate: 'do LLL' }}</span>
					<span>-</span>
					<span>{{ range.to | formatDate: 'do LLL' }}</span>
				</ng-template>
				<ng-template #defaultDayViewTemplate>
					<ng-container *ngIf="range.from && range.to; else noRange">
						<span>{{ range.from | formatDate: 'do LLL' }}</span>
						<span>-</span>
						<span>{{ range.to | formatDate: 'do LLL' }}</span>
					</ng-container>
					<ng-template #noRange>{{ 'utils.pickTimeRange' | translate }}</ng-template>
				</ng-template>
			</div>
		</button>
		<button
			(click)="this.goForward(range)"
			[disabled]="disabled"
			class="tr-right-btn"
			fxHide.lt-md
			mat-icon-button
		>
			<mat-icon>chevron_right</mat-icon>
		</button>
	</div>
	<mat-menu
		[overlapTrigger]="true"
		#changeRangePresetMenu="matMenu"
	>
		<p class="px-5">{{ 'time-range.choose-timeframe' | translate }}</p>
		<mat-divider class="mb-2"></mat-divider>
		<div class="flex flex-col gap-1">
			<ng-container *ngIf="this.defaultRanges.value$ | async as dranges">
				<ng-container *ngFor="let r of dranges | iterateObject">
					<ng-container *ngIf="(this.range$ | async)?.name === r.name; else nonActive">
						<button
							(click)="$event.stopPropagation(); $event.preventDefault()"
							[disabled]="true"
							class="bg-primary-2"
							mat-menu-item
						>
							{{ r.name | translate }}
						</button>
					</ng-container>
					<ng-template #nonActive>
						<button
							(click)="this.selectRange(r)"
							[disabled]="disabled"
							mat-menu-item
						>
							{{ r.name | translate }}
						</button>
					</ng-template>
				</ng-container>
			</ng-container>
		</div>
	</mat-menu>
</div>
